@if (loading()) {
  <div class="flex items-center gap-2 text-surface-500 text-sm py-4">
    <i class="pi pi-spin pi-spinner"></i>
    <span>Loading profile…</span>
  </div>
} @else if (error()) {
  <div class="text-red-600 text-sm py-4" role="alert">
    {{ error() }}
  </div>
} @else if (!sectionsWithDisplayValues().length) {
  <div class="flex flex-col items-center justify-center gap-3 text-surface-500 text-sm py-8 px-4" role="status">
    <i class="pi pi-user text-4xl text-surface-300" aria-hidden="true"></i>
    @if (sections().length === 0) {
      <p class="text-center">Select a client to view their profile.</p>
    } @else {
      <p class="text-center">No profile fields are available to display for this client.</p>
    }
  </div>
} @else {
  <div class="client-profile">
    @for (section of sectionsWithDisplayValues(); track section.sectionDomId) {
      <section
        class="profile-section border border-surface-200 rounded-lg bg-surface-0 overflow-hidden"
        [attr.aria-labelledby]="section.sectionDomId"
      >
        <h2
          [id]="section.sectionDomId"
          class="text-sm font-semibold text-surface-700 bg-surface-50 px-4 py-2 border-b border-surface-200 flex items-center justify-between gap-2"
        >
          <span class="flex items-center gap-2">
            <i class="pi {{ section.sectionIcon }} text-surface-500" aria-hidden="true"></i>
            {{ section.title }}
          </span>
          @if (
            section.subsections.length === 1 &&
            !section.subsections[0].subsectionTitle &&
            section.subsections[0].hasEditableItems
          ) {
            <p-button
              icon="pi pi-pencil"
              ariaLabel="Edit section"
              variant="text"
              [rounded]="true"
              size="small"
              (onClick)="editService.openSectionEdit(section.subsections[0].asSectionForEdit)"
            ></p-button>
          }
        </h2>
        <div class="divide-y divide-surface-100">
        @for (sub of section.subsections; track sub.blockId) {
          <div class="py-1">
          @if (sub.subsectionTitle) {
            <div class="flex items-center justify-between gap-2 px-4 pt-3 pb-1">
              <h3 class="text-xs font-semibold text-surface-600 uppercase tracking-wide m-0">
                {{ sub.subsectionTitle }}
              </h3>
              @if (
                sub.hasEditableItems &&
                (section.subsections.length > 1 || sub.subsectionTitle)
              ) {
                <p-button
                  icon="pi pi-pencil"
                  ariaLabel="Edit subsection"
                  variant="text"
                  [rounded]="true"
                  size="small"
                  (onClick)="editService.openSectionEdit(sub.asSectionForEdit)"
                ></p-button>
              }
            </div>
          } @else if (section.subsections.length > 1 && sub.hasEditableItems) {
            <div class="flex justify-end px-4 pt-2">
              <p-button
                icon="pi pi-pencil"
                ariaLabel="Edit subsection"
                variant="text"
                [rounded]="true"
                size="small"
                (onClick)="editService.openSectionEdit(sub.asSectionForEdit)"
              ></p-button>
            </div>
          }
          <dl class="px-4 py-3 flex flex-col gap-3">
            @for (item of sub.items; track item.key ?? item.label) {
              <div class="flex flex-col gap-1">
                <dt class="text-surface-500 font-bold text-xs uppercase tracking-wide">
                  {{ item.label }}
                </dt>
                <dd class="text-surface-800 text-sm min-h-[2rem] flex items-center gap-2 flex-wrap">
                  <span class="text-surface-700">
                    @switch (item.valueDisplayKind) {
                      @case ('date') {
                        @if (
                          item.displayValue !== null &&
                          item.displayValue !== undefined &&
                          item.displayValue !== ''
                        ) {
                          {{ item.displayValue | date: 'mediumDate' }}
                        } @else {
                          —
                        }
                      }
                      @case ('currency') {
                        @if (item.currencyAmount !== null) {
                          {{ item.currencyAmount | currency: 'USD':'symbol':'1.2-2' }}
                        } @else {
                          {{ item.displayValue ?? '—' }}
                        }
                      }
                      @case ('phone') {
                        <span class="tabular-nums tracking-wide text-surface-700">{{
                          item.formattedPhone ?? item.displayValue ?? '—'
                        }}</span>
                      }
                      @default {
                        {{ item.displayValue ?? '—' }}
                      }
                    }
                  </span>
                  @if (item.preferred === true) {
                    <span
                      class="text-xs font-medium text-primary-800 bg-primary-50 px-2 py-0.5 rounded"
                    >Preferred</span>
                  }
                </dd>
              </div>
            }
          </dl>
          </div>
        }
        </div>
      </section>
    }
  </div>
}
